import { cn } from '@utils/cn';
import { cva, type VariantProps } from 'class-variance-authority';

export type AgentActiveStatus = 'active' | 'inactive' | 'draft';

const dotVariants = cva('rounded-full absolute', {
  variants: {
    variant: {
      inactive: 'border-elz-neutral-10 bg-transparent',
      active: 'bg-elz-success-10 border-elz-success-10',
    },
    size: {
      sm: 'size-6 -right-2 -bottom-2 border-[1.5px]',
      md: 'size-9 -right-3 -bottom-3 border-2',
    },
  },
  defaultVariants: {
    variant: 'inactive',
    size: 'sm',
  },
});

export type DotVariants = VariantProps<typeof dotVariants>;

type AgentActiveDotProps = DotVariants & {
  className?: string;
};
const AgentActiveDot = ({ variant, size, className }: AgentActiveDotProps) => {
  return <div className={cn(dotVariants({ variant, size }), className)} />;
};

export default AgentActiveDot;
